@if (listing){
<!-- loaded icon -->
@if (!listing.hasMore) {
<div class="flex flex-justify-center">
    <span class="_products-loaded-icon fs-11 col-3 icon-tick"></span>
</div>
}
<!-- number of viewed elements  -->
<p class="p1 col-1"
   [ngClass]="!listing.hasMore && 'm-t-3'">{{ 'Viewing' | translate}}&nbsp;<span
          class="s1">{{listing.visibleQty}}&nbsp;</span>{{ 'of' |
    translate}}&nbsp;<span class="s1">{{listing.getTotal()}}</span>
</p>
<!-- progress bar -->
<div class="m-t-7">
    <progress-bar [currentValue]="listing.visibleQty"
                  [maxValue]="listing.getTotal()"></progress-bar>
</div>
<!-- view more button -->
<button [buttonStyle]="'button-1'"
        class="m-t-7"
        role="button"
        [disabled]="!listing.hasMore"
        (click)="listing.increaseLimit()"
        [attr.aria-label]="'View more' | translate">{{'Load more' | translate}}</button>
}
